import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flush", "layout", "maxWidth", "primaryContent", "reverseOrder", "secondaryContent", "secondaryContentWidth", "titleText"];
import { isValidElement } from 'react';
import styled from 'foundations-theming/utils';
import { Text } from '../../../components/Text/Text';
import { useTheme } from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { toPx } from '../../../utils/toPx';
import { TFlex } from '../TFlex';
import { Box } from '../Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Outer = styled.div.withConfig({
  displayName: "EmptyState__Outer",
  componentId: "sc-1kkvbgn-0"
})(props => {
  const theme = props.theme;
  const isVertical = props.$layout === 'vertical';
  const cssStyles = props.$cssStyles;
  return Object.assign({
    margin: `${isVertical ? theme.space['1000'] : `calc(2 * ${theme.space['1000']})`} auto`,
    display: 'block',
    marginBottom: props.$flush ? theme.space['0'] : undefined,
    marginTop: props.$flush ? theme.space['0'] : undefined,
    paddingInlineStart: theme.space['1200'],
    maxWidth: toPx(props.$maxWidth),
    width: '100%'
  }, cssStyles);
});
export const EmptyState = _ref => {
  let {
      flush = false,
      layout = 'horizontal',
      maxWidth = 815,
      primaryContent,
      reverseOrder = false,
      secondaryContent,
      secondaryContentWidth = 350,
      titleText
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps,
    domProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const theme = useTheme();
  const computedPadding = parseInt(theme.space['1200'], 10);
  const computedSecondaryContentWidth = secondaryContentWidth + computedPadding;
  const computedPrimaryContentWidth = secondaryContent ? parseInt(theme.space['1700'], 10) : '100%';
  const title =
  // @ts-expect-error Formatted* components need types to detect isI18nElement
  /*#__PURE__*/isValidElement(titleText) && !(titleText !== null && titleText !== void 0 && titleText.type.isI18nElement) ? titleText : /*#__PURE__*/_jsx(Text, {
    as: "h4",
    marginBlockEnd: "400",
    children: titleText
  });
  return /*#__PURE__*/_jsx(Outer, Object.assign({
    $flush: flush,
    $layout: layout,
    $maxWidth: maxWidth,
    $cssStyles: cssStyles
  }, domProps, {
    children: /*#__PURE__*/_jsxs(TFlex, {
      marginInlineStart: "-1200",
      marginBlockStart: "-500",
      flexDirection: layout === 'vertical' ? 'column' : 'row',
      flexWrap: "wrap",
      children: [/*#__PURE__*/_jsxs(Box, {
        margin: "auto",
        paddingInlineStart: "1200",
        paddingBlockStart: "500",
        marginBlockStart: "0",
        textAlign: layout === 'vertical' ? 'center' : 'left',
        order: reverseOrder ? 1 : 0,
        flexBasis: layout === 'horizontal' ? computedPrimaryContentWidth : 'auto',
        flexGrow: 9999,
        flexShrink: 1,
        children: [titleText && title, primaryContent]
      }), secondaryContent && /*#__PURE__*/_jsx(Box, {
        margin: "auto",
        paddingInlineStart: "1200",
        paddingBlockStart: "500",
        marginBlockStart: "0",
        marginBlockEnd: layout === 'vertical' ? '500' : '0',
        textAlign: layout === 'vertical' ? 'center' : 'left',
        order: reverseOrder ? 0 : 1,
        flexBasis: layout === 'horizontal' ? computedSecondaryContentWidth : 'auto',
        flexGrow: 1,
        flexShrink: 1,
        inlineSize: layout === 'vertical' ? `${computedSecondaryContentWidth}px` : undefined,
        children: secondaryContent
      })]
    })
  }));
};